export const setTaskDictionary = (state, payload) => {
  state.taskDictionaries.general = payload;
};

export const setTasks = (state, payload) => {
  state.tasks = payload;
};
export const setActiveTasks = (state, payload) => {
  state.activeTasks = payload;
};

export const setAllActiveTasks = (state, payload) => {
  state.allActiveTasks = payload;
};

export const setFetchTasks = (state, payload) => {
  state.getFetchTasks = payload;
};

export const SetOpenRepForEmails = (state, payload) => {
  state.openRepForEmails = payload;
};


export const setActiveTasksCounter = (state, payload) => {
  state.activeTasksCounter = payload;
};

export const setActiveMeetingsCounter = (state, payload) => {
  state.activeMeetingsCounter = payload;
};

export const setChartDataToTable = (state, payload) => {
  state.chartDataToTable = payload;
};
export const setPreOpenTaskFromChart = (state, payload) => {
  state.preOpenTaskFromChart = payload;
};
export const setPreOpenMainTaskWindowFromHeader = (state, payload) => {
  state.preOpenMainTaskWindowFromHeader = payload;
};

export const setQueryForCharts = (state, payload) => {
  state.queryForCharts = payload;
};
export const setActiveTimer = (state, payload) => {
  state.activeTimer = payload.activeTimer;
};
export const setStopTimer = (state, payload) => {
  state.stopTimer = payload.stopTimer;
};
export const setFilterByTaskId = (state, payload) => {
  state.tasksFilteringVuexObj = payload;
  state.preOpenMeetingFromMsgCenter = true;
};

export const setResetQuery = (state, payload) => {
  state.resetQuery = payload;
  state.preOpenTaskFromChart = false;
  state.preOpenMeetingFromMsgCenter = false;
  state.tasksFilteringVuexObj = {};
};
export const setCategories = (state, payload) => {
  state.categories = payload.data;
};
export const setTopThreeUsersFromLast100 = (state, payload) => {
  state.topThreeUsersFromLast100 = payload.data;
};
export const setTopFiveTagsFromLast100 = (state, payload) => {
  state.topFiveTagsFromLast100 = payload;
};
export const setChartsViewBlocks = (state, payload) => {
  state.chartsViewBlocks = payload;
};
